/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DutyScheduleCounselorSnapshotResponse
 */
export interface DutyScheduleCounselorSnapshotResponse {
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleCounselorSnapshotResponse
     */
    counselorId: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleCounselorSnapshotResponse
     */
    userCode: string;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleCounselorSnapshotResponse
     */
    weeklyHours: number;
}

/**
 * Check if a given object implements the DutyScheduleCounselorSnapshotResponse interface.
 */
export function instanceOfDutyScheduleCounselorSnapshotResponse(value: object): value is DutyScheduleCounselorSnapshotResponse {
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('weeklyHours' in value) || value['weeklyHours'] === undefined) return false;
    return true;
}

export function DutyScheduleCounselorSnapshotResponseFromJSON(json: any): DutyScheduleCounselorSnapshotResponse {
    return DutyScheduleCounselorSnapshotResponseFromJSONTyped(json, false);
}

export function DutyScheduleCounselorSnapshotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleCounselorSnapshotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'counselorId': json['counselorId'],
        'userCode': json['userCode'],
        'weeklyHours': json['weeklyHours'],
    };
}

export function DutyScheduleCounselorSnapshotResponseToJSON(json: any): DutyScheduleCounselorSnapshotResponse {
    return DutyScheduleCounselorSnapshotResponseToJSONTyped(json, false);
}

export function DutyScheduleCounselorSnapshotResponseToJSONTyped(value?: DutyScheduleCounselorSnapshotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counselorId': value['counselorId'],
        'userCode': value['userCode'],
        'weeklyHours': value['weeklyHours'],
    };
}

